import { useEffect, useState } from "react";

export function useLoadPct(active, durationMs = 20000) {
  const [pct, setPct] = useState(0);
  useEffect(() => {
    if (!active) {
      setPct(0);
      return undefined;
    }
    const t0 = Date.now();
    const id = setInterval(() => {
      setPct(Math.min(92, Math.round(((Date.now() - t0) / durationMs) * 92)));
    }, 250);
    return () => clearInterval(id);
  }, [active, durationMs]);
  return active ? Math.max(pct, 6) : 0;
}

export default function LoadProgress({
  active,
  label = "Working",
  durationMs = 20000,
}) {
  const pct = useLoadPct(active, durationMs);
  if (!active) return null;
  return (
    <div className="w-full space-y-1">
      <p className="text-[11px] font-medium text-slate-600 tabular-nums">
        {label}: {pct}% complete · {100 - pct}% left
      </p>
      <div className="h-1.5 rounded-full bg-slate-200 overflow-hidden">
        <div
          className="h-full bg-indigo-500 transition-all duration-300"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
